import React, { useState } from "react";

const NonFrontalGizmo = ({isOpen}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      style={{ width: "60px", height: "60px", cursor: "pointer" }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
  <circle cx="11" cy="11" r="11" fill="#1A1D25"/>
</svg>
    </div>
  )
}

export default NonFrontalGizmo
